const axios = require("axios").default;
const qs = require("qs");

// for id scanner api calls
const instance = axios.create({ baseURL: "/verify/" });

// for OLA api calls
const olaInstance = axios.create({ baseURL: "/update/" });

export default function () {
  return {
    // /**
    //  * Get the url for the OLA so we can hit certain api endpoints
    //  * set the returned url as the base url for the ola instance of Axios
    //  * @param none
    //  * @returns url for the OLA
    //  */
    // getBaseOlaUrl: () => {
    //   return instance
    //     .get(`GetBaseOlaUrl`)
    //     .then((result) => {
    //       olaInstance.defaults.baseURL = result.data;
    //       return result;
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       return error;
    //     });
    // },
    /**
     * signal OLA that id scanning has started for this application
     * @param {guid, scanUser, token} payload
     * @returns true
     */
    olaStartScan: (payload) =>
      olaInstance.get(`startscan?${qs.stringify(payload)}`),
    /**
     * signal OLA that id scanning has started for this application
     * @param {guid, scanUser, token} payload
     * @returns true
     */ olaStopScan: (payload) =>
      olaInstance.get(`stopscan?${qs.stringify(payload)}`),
    /**
     * Check back of ID if it's an image and not a PDF417 barcode
     * frontimage=fi&backimage=bi&token=test
     */
    backImageIdCheck: (payload) => instance.post(`BackImageIdCheck`, payload),
    /**
     * Check back of ID if it's a PDF417 barcode
     * {"frontimage":"fi","backEncodedData": {"PDF417": "encoded" },"token":"test"}
     */
    backEncodedIdCheck: (payload) =>
      instance.post(`BackEncodedIdCheck`, payload),
    /**
     * for submitting a passport image
     * @param {image, token} payload
     * @returns promise, axios result
     */
    passportCheck: (payload) => instance.post(`PassportCheck`, payload),
  };
}
